import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerLibroMastroModalComponent } from './worker-libro-mastro-modal';

export const WorkerLibroMastroModalModule: string = ng
    .module('worker-libro-mastro-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerLibroMastroModalComponent', WorkerLibroMastroModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-libro-mastro-modal/worker-libro-mastro-modal.module.ts